import { City } from "country-state-city";
import { onImageHandler } from "../common/Image upload on bucket/UploadImageOnBucket";
import { toast } from "react-toastify";

const usePublishArticle = () =>{

    const handleUpload = async ({e,setImageLoading,setUpdate}) => {
        const file = e?.target?.files?.[0];
        if (!file) return;

        // Validate dimensions: only allow exactly 300 x 800 
        const getImageDimensions = (imgFile) =>
          new Promise((resolve, reject) => {
            const url = URL.createObjectURL(imgFile);
            const img = new Image();
            img.onload = () => {
              resolve({ width: img.width, height: img.height });
              URL.revokeObjectURL(url);
            };
            img.onerror = (err) => {
              URL.revokeObjectURL(url);
              reject(err);
            };
            img.src = url;
          });

        try {
          const { width, height } = await getImageDimensions(file);
          if (!(width === 300 && height === 800)) {
            toast.error("Please upload image size 300 × 800 only.");
            e.target.value = null; // allow re-selecting same file
            return;
          }
        } catch (err) {
          toast.error("Unable to read image dimensions. Please try another image.");
          e.target.value = null;
          return;
        }

        setImageLoading(true);
        const data = await onImageHandler(e);
        if (Array.isArray(data) && data?.[1]?.location) {
          setUpdate((prev) => ({ ...prev, [e.target.name]: data[1].location }));
        } else if (typeof data === "string") {
          toast.error(data);
        } else {
          toast.error("Image upload failed. Please try again.");
        }
        setImageLoading(false);
      };

      const handleChangeRegion = ({e,setSelectedRegion,setCityArr})=>{ 
        setSelectedRegion((prev)=>({...prev,state:e,city:null}))
        console.log(e.value)
        const StatesCity = City.getCitiesOfState('IN',e.value); 
        setCityArr(StatesCity.map((item)=>({value:item?.name,label:item?.name})));
      }

      const handleChangeRegionForMeraCity = ({e,setSelectedRegion,setMeraCityArr})=>{
        setSelectedRegion((prev)=>({...prev,meraState:e,meraCity:null}))
        const StatesCity = City.getCitiesOfState('IN',e.value); // 'IN' is the ISO code for India
        setMeraCityArr(StatesCity.map((item)=>({value:item?.name,label:item?.name})));
      }
    
    return({handleUpload,handleChangeRegion,handleChangeRegionForMeraCity})
}

export default usePublishArticle 